import { useNavigate } from 'react-router-dom';
import { useSelection } from '@/app/SelectionContext';
import { Dropdown, type DropdownOption } from './Dropdown';

/**
 * Restaurant switcher.
 *
 * Only business units of type RESTAURANT appear here, and they come from the
 * API — nothing is hard-coded, so a second restaurant shows up on its own.
 *
 * The consolidated company view and the production kitchen are *places*, not
 * restaurants, and they are reached from the left menu («Вся компания»,
 * «Производство»). Listing them here as well duplicated that menu and made
 * the control read as a general navigator instead of "which restaurant am I
 * looking at". The underlying selection context still holds every unit type,
 * so those routes keep working exactly as before.
 */
export function BusinessUnitSelector() {
  const { units, scope, setScope, selectedUnit, loading } = useSelection();
  const navigate = useNavigate();

  const restaurants = units.filter((unit) => unit.type === 'RESTAURANT');

  const options: DropdownOption[] = restaurants.map((unit) => ({
    value: unit.id,
    label: unit.name,
  }));

  const label = loading
    ? 'Загрузка…'
    : selectedUnit?.type === 'RESTAURANT'
      ? selectedUnit.name
      : (restaurants[0]?.name ?? 'Нет ресторанов');

  const handleSelect = (value: string) => {
    setScope(value);
    navigate('/');
  };

  return (
    <Dropdown
      icon="building"
      value={scope}
      label={label}
      options={options}
      onSelect={handleSelect}
      disabled={loading || restaurants.length === 0}
    />
  );
}
